import ApiStore from "./ApiStore";
import ApplicationStore from "./ApplicationStore";
import EducationStore from "./EducationStore";
import EmployeesStore from "./EmployeesStore";
import EventStore from "./EventStore";
import ProjectDocumentationStore from "./ProjectDocumentationStore";
import ProjectsStore from "./ProjectsStore";
import ProjectTaskStore from "./ProjectTasksStore";
import TaskStore from "./TaskStore";
import SalaryStore from "./SalaryStore";
import TimeReportStore from "./TimeReportStore";
import TariffPlansStore from "./TariffPlansStore";
import PaymentStore from "./PaymentStore";
import TestsStore from "./TestsStore";
import ResourceStore from "./ResourcesStore";
import KanbanTaskStore from "./KanbanTaskStores";
import ProjectFilesStore from "./ProjectFilesStore";
import FinanceStore from "./FinanceStore";
import CRMStore from "./CRMStore";
import ProjectEventStore from "./ProjectEventStore";
import TicketChatStore from "./TicketChatStore";
import TicketStore from "./TicketStore";
import AnonymousStore from "./AnonymousStore";
import FavoriteProjectsStore from "./FavoriteProjectsStore";
import ProjectDocumentationFolderStore from "./ProjectDocumentationFolderStore";
import CountryStore from "./CountryStore";
import CountryPaymentSystemStore from "./CountryPaymentSystemStore";
import CurrencyExchangeRateStore from "./CurrencyExchangeRateStore";

class RootStore {
  apiStore: ApiStore;
  applicationStore: ApplicationStore;
  employeesStore: EmployeesStore;
  projectsStore: ProjectsStore;
  projectTaskStore: ProjectTaskStore;
  taskStore: TaskStore;
  projectDocumentationStore: ProjectDocumentationStore;
  projectDocumentationFolderStore: ProjectDocumentationFolderStore;
  timeReportStore: TimeReportStore;
  eventStore: EventStore;
  educationStore: EducationStore;
  salaryStore: SalaryStore;
  tariffPlansStore: TariffPlansStore;
  paymentStore: PaymentStore;
  countryPaymentSystemStore: CountryPaymentSystemStore;
  testsStore: TestsStore;
  resourceStore: ResourceStore;
  kanbanTaskStore: KanbanTaskStore;
  projectFilesStore: ProjectFilesStore;
  financeStore: FinanceStore;
  crmStore: CRMStore;
  projectEventStore: ProjectEventStore;
  // googleCalendarStore: GoogleCalendarStore;
  // teamsCalendarStore: TeamsCalendarStore;
  ticketChatStore: TicketChatStore;
  ticketStore: TicketStore;
  anonymousStore: AnonymousStore;
  favoriteProjectsStore: FavoriteProjectsStore;
  countryStore!: CountryStore;
  currencyExchangeRateStore!: CurrencyExchangeRateStore;

  constructor() {
    this.apiStore = new ApiStore();
    this.countryStore = new CountryStore(this.apiStore);
    this.applicationStore = new ApplicationStore(this.apiStore, this.countryStore);
    this.employeesStore = new EmployeesStore(this.apiStore, this.applicationStore);
    this.projectsStore = new ProjectsStore(this.apiStore);
    this.projectTaskStore = new ProjectTaskStore(this.apiStore);
    this.projectDocumentationStore = new ProjectDocumentationStore(this.apiStore);
    this.projectDocumentationFolderStore = new ProjectDocumentationFolderStore(this.apiStore);
    this.timeReportStore = new TimeReportStore(this.apiStore, this.applicationStore, this.employeesStore, this.projectsStore);
    this.eventStore = new EventStore(this.apiStore);
    this.taskStore = new TaskStore(this.apiStore);
    this.educationStore = new EducationStore(this.apiStore);
    this.salaryStore = new SalaryStore(this.apiStore);
    this.currencyExchangeRateStore = new CurrencyExchangeRateStore(this.apiStore);
    this.tariffPlansStore = new TariffPlansStore(this.apiStore, this.currencyExchangeRateStore);
    this.paymentStore = new PaymentStore(this.apiStore);
    this.countryPaymentSystemStore = new CountryPaymentSystemStore(this.apiStore);
    this.testsStore = new TestsStore(this.apiStore, this.applicationStore);
    this.resourceStore = new ResourceStore(this.apiStore);
    this.kanbanTaskStore = new KanbanTaskStore(this.apiStore);
    this.projectFilesStore = new ProjectFilesStore(this.apiStore);
    this.financeStore = new FinanceStore(this.apiStore);
    this.crmStore = new CRMStore(this.apiStore);
    this.projectEventStore = new ProjectEventStore(this.apiStore);
    // this.googleCalendarStore = new GoogleCalendarStore(this.apiStore);
    // this.teamsCalendarStore  = new TeamsCalendarStore(this.apiStore);
    this.ticketChatStore = new TicketChatStore(this.apiStore);
    this.ticketStore = new TicketStore(this.apiStore);
    this.anonymousStore = new AnonymousStore(this.apiStore);
    this.favoriteProjectsStore = new FavoriteProjectsStore(this.apiStore);
  }

  clearLocalStorages = () => {
    // this.applicationStore.clearDropdownsLocalStorages();
  };
}

export default RootStore;